import { IoLogoGooglePlaystore } from 'react-icons/io5';
import styled from '@emotion/styled';
import { DARK_GRAY } from '../../../styles/constants/color';

const Button = styled.button`
  width: auto;
  height: auto;
  text-align: center;
`;

interface Props {
  color?: string;
}

/**
 *  쏠카 구글플레이스토어 링크 버튼 컴포넌트
 * @param {string} color 버튼의 색깔 defalut: #666;
 *  */
function ScGooglePlaystore({ color }: Props): JSX.Element {
  const onClick = (): void => {
    window.open('https://play.google.com/store/apps/details?id=kr.ten.solecar');
  };

  return (
    <Button onClick={onClick}>
      <IoLogoGooglePlaystore size={26} color={color || DARK_GRAY} />
    </Button>
  );
}

export default ScGooglePlaystore;
